<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="800">
      <v-btn
        id="oppoButton"
        slot="activator"
        :color="
          opportunity.companies.length == currentOpportunity.companies.length
            ? 'theme_primary_lighten1'
            : 'orange'
        "
        dark
        small
        round
        depressed
        >{{ opportunity.companies.length }} companies</v-btn
      >
      <v-card>
        <v-toolbar dense flat card color="theme_primary">
          <v-text-field
            v-model="currentOpportunity.name"
            :label="currentOpportunity.name"
            single-line
            append-icon="edit"
            class="modalHeader"
            solo
            background-color="transparent"
          />
        </v-toolbar>

        <v-card-text>
          <v-text-field
            v-model.trim="search"
            label="instant search..."
            single-line
            append-icon="search"
            class="search"
          />

          <template>
            <v-layout row>
              <v-flex xs12 sm12>
                <v-card flat>
                  <v-list>
                    <div
                      v-for="company in filteredItems(
                        currentOpportunity.companies
                      )"
                      :key="company.name"
                    >
                      <v-list-tile>
                        {{ company.name }}
                        <v-list-tile-content>
                          <v-list-tile-title
                            v-html="company.title"
                          ></v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                          <v-icon @click="removeFromList(company.id)"
                            >delete</v-icon
                          >
                        </v-list-tile-action>
                      </v-list-tile>
                      <v-divider></v-divider>
                    </div>
                  </v-list>
                </v-card>
              </v-flex>
            </v-layout>
          </template>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" @click="update">
            <v-icon small class="pr-2" color="white">save</v-icon>Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import OPPORTUNITY_UPDATE from "../../graphql/opportunities/update.gql";

export default {
  props: {
    opportunity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      search: "",
      currentOpportunity: {},
    };
  },
  created() {
    this.currentOpportunity = JSON.parse(JSON.stringify(this.opportunity));
  },
  methods: {
    filteredItems(companies) {
      return companies.filter((item) => {
        return item.name.toLowerCase().includes(this.search.toLowerCase());
      });
    },

    removeFromList(companyId) {
      this.currentOpportunity.companies.splice(
        this.currentOpportunity.companies.indexOf(
          this.currentOpportunity.companies.find((e) => e.id == companyId)
        ),
        1
      );
      this.currentOpportunity.company_ids = this.currentOpportunity.companies.map(
        (e) => e.id
      );
    },
    update() {
      this.dialog = false;
      this.sendMutation(
        "updated",
        "opportunity",
        OPPORTUNITY_UPDATE,
        this.currentOpportunity
      );
    },
  },
};
</script>

<style scoped>
.modalHeader >>> .v-input__slot * {
  color: white !important;
}
</style>
